import { gql } from "@apollo/client";

// Available mutations in backend
export const RESET_PASSWORD = gql`
  mutation resetPassword($email: String!, $areaType: String) {
    resetPassword(email: $email, areaType: $areaType) {
      success
    }
  }
`;

export const CONFIRM_RESET_PASSWORD = gql`
  mutation confirmResetPassword(
    $token: String!
    $password: String!
    $uuid: UUID!
  ) {
    resetPasswordConfirm(token: $token, password: $password, uuid: $uuid) {
      success
    }
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile(
    $firstName: String
    $lastName: String
    $dateOfBirth: Date
    $image: Upload
    $phoneNumber: String
    $defaultLanguage: Language
  ) {
    updateUserProfile(
      firstName: $firstName
      lastName: $lastName
      dateOfBirth: $dateOfBirth
      image: $image
      phoneNumber: $phoneNumber
      defaultLanguage: $defaultLanguage
    ) {
      success
      message
      user {
        id
        email
        firstName
        lastName
        dateOfBirth
        phoneNumber
        defaultLanguage
        image {
          url
          alt
        }
      }
    }
  }
`;

// Deprecated mutations - not available in backend
// export const FEEDBACK = gql`...`; // Not available
// export const PREFERENCES = gql`...`; // Not available
// export const EMAIL = gql`...`; // Not available
// export const SETUP_PASSWORD = gql`...`; // Not available
// export const SUGGEST_MEMBER = gql`...`; // Not available
// export const CREATE_INVITATION = gql`...`; // Not available
// export const MEMBER_CONTACT_FORM = gql`...`; // Not available
